export const projects = {
  it: {
    title: "Progetti",
    techStack: "Stack Tecnologico",
    items: [
      {
        title: "Automazione Aziendale AI & Flussi di Lavoro Intelligenti",
        description: "Piattaforma di automazione basata su AI per l'ottimizzazione dei processi aziendali",
        percentage: "40%",
        achievements: [
          "Sviluppato sistemi di automazione del flusso di lavoro che hanno ridotto i tempi di approvazione del 50%",
          "Integrato API ChatGPT e Power Automate per l'automazione intelligente del servizio clienti",
          "Progettato strumenti di elaborazione dati basati su AI per la gestione dei flussi di lavoro aziendali"
        ]
      },
      {
        title: "CRM e Sistemi di Approvazione del Flusso di Lavoro",
        description: "Costruito un CRM basato su PowerApps e un sistema di approvazione per le aziende",
        percentage: "20%",
        achievements: [
          "Sviluppato software CRM personalizzato che ha ottimizzato il monitoraggio di clienti e vendite",
          "Creato strumenti di approvazione del flusso di lavoro utilizzando Power Automate, riducendo i tempi di elaborazione del 60%",
          "Automatizzato la sincronizzazione dei dati su più piattaforme (SharePoint, SQL, Azure DBs)"
        ]
      },
      {
        title: "Business Intelligence e Analisi dei Dati",
        description: "Progettato dashboard Power BI avanzate per insight aziendali in tempo reale",
        percentage: "20%",
        achievements: [
          "Creato modelli di analisi basati su AI per scoprire 230.000€ di entrate non sfruttate",
          "Sviluppato dashboard KPI che hanno migliorato l'efficienza del processo decisionale del 40%",
          "Automatizzato pipeline di dati e flussi di lavoro di reporting, eliminando processi manuali"
        ]
      },
      {
        title: "Sviluppo Web e App",
        description: "Costruito siti web scalabili e applicazioni web aziendali per l'automazione aziendale",
        percentage: "20%",
        achievements: [
          "Sviluppato portali aziendali personalizzati per l'interazione con i clienti e il monitoraggio del flusso di lavoro",
          "Creato app integrate con AI che automatizzano i report e la comunicazione con i clienti",
          "Costruito applicazioni web full-stack per la gestione dei flussi di lavoro e delle approvazioni dei progetti"
        ]
      }
    ]
  },
  en: {
    title: "Projects",
    techStack: "Tech Stack",
    items: [
      {
        title: "AI Business Automation & Intelligent Workflows",
        description: "AI-driven automation platform for business process optimization",
        percentage: "40%",
        achievements: [
          "Developed workflow automation systems that reduced approval times by 50%",
          "Integrated ChatGPT API & Power Automate for intelligent customer service automation",
          "Designed AI-powered data processing tools for enterprise workflow management"
        ]
      },
      {
        title: "CRM & Workflow Approval Systems",
        description: "Built a PowerApps-based CRM & Approval System for enterprises",
        percentage: "20%",
        achievements: [
          "Developed custom CRM software that streamlined client & sales tracking",
          "Created workflow approval tools using Power Automate, reducing processing times by 60%",
          "Automated data syncing across multiple platforms (SharePoint, SQL, Azure DBs)"
        ]
      },
      {
        title: "Business Intelligence & Data Analytics",
        description: "Designed advanced Power BI dashboards for real-time business insights",
        percentage: "20%",
        achievements: [
          "Created AI-powered analytics models to uncover $230K in untapped revenue",
          "Developed KPI dashboards that improved decision-making efficiency by 40%",
          "Automated data pipelines & reporting workflows, eliminating manual processes"
        ]
      },
      {
        title: "Web & App Development",
        description: "Built scalable websites & enterprise web apps for business automation",
        percentage: "20%",
        achievements: [
          "Developed custom business portals for client interaction & workflow tracking",
          "Created AI-integrated apps that automate reporting & client communication",
          "Built full-stack web applications for managing project workflows & approvals"
        ]
      }
    ]
  }
};